"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given number is less than the threshold value.
 *
 * @export
 * @class IsLessThanValidator
 * @implements {PropertyValidator<number>}
 */
class IsLessThanValidator {
    constructor(threshold) {
        this.threshold = threshold;
    }
    isValid(input) {
        if (typeof input === "undefined" || input === null) {
            return false;
        }
        return input < this.threshold;
    }
}
exports.IsLessThanValidator = IsLessThanValidator;
//# sourceMappingURL=IsLessThanValidator.js.map